import { combineReducers } from "@reduxjs/toolkit";
import contextReducer from "features/context/contextSlice";
import probeReducer from "features/probe/probeSlice";
import hubReducer from "features/hub/hubSlice";
import logsReducer from "features/logs/logsSlice";

const rootReducer = combineReducers({
  context: contextReducer,
  probe: probeReducer,
  hub: hubReducer,
  logs: logsReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
